import { render, staticRenderFns } from "./myDelfi.vue?vue&type=template&id=4b69ebaf"
import script from "./myDelfi.vue?vue&type=script&lang=ts"
export * from "./myDelfi.vue?vue&type=script&lang=ts"
import style0 from "./myDelfi.vue?vue&type=style&index=0&id=4b69ebaf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports